<h3 class="schema__advantage-item-title">
  <span>
    {{ 'main.schemas.fastPerformance' | translate }}
  </span>
  <br />
  @if (isSelectedRu()) {
    <span>{{ 'main.schemas.fastPerformance2' | translate }}</span>
  }
</h3>

<div class="schema__card schema__paragraph-regular">
  {{ 'main.schemas.lightningFast' | translate }}
</div>

<img
  width="200"
  loading="lazy"
  alt="Three AstralFund credit cards"
  src="/assets/schemas/card-5-bg.png"
  class="schema__image schema__image_5"
/>
